module.exports = __webpack_public_path__ + "static/img/index_01.ff0d766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_01.png
// module id = x4T8
// module chunks = 1